import { render, staticRenderFns } from "./full-bs.vue?vue&type=template&id=ef7dfbec&"
import script from "./full-bs.vue?vue&type=script&lang=js&"
export * from "./full-bs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef7dfbec')) {
      api.createRecord('ef7dfbec', component.options)
    } else {
      api.reload('ef7dfbec', component.options)
    }
    module.hot.accept("./full-bs.vue?vue&type=template&id=ef7dfbec&", function () {
      api.rerender('ef7dfbec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/full-bs.vue"
export default component.exports